import { IndexedArray } from 'utils/arrays/arrayUtils';

export interface OrderFilterResult {
    idx: number;
    passes: boolean;
}

export interface BlotterFilteredOrdersState {
    /*
     * Indexed array holding results of the current filter function against the equivalent orders indexed array
     * The items in this array are updated by the updateActiveBlotterFilterResultsOnOrdersStreamUpdatedMiddleware middleware
     */
    results: IndexedArray<OrderFilterResult>;
    /*
     * Incremented when the set of orders that pass the filters change, or a property in the results changes
     * This forces the useBlotterFilteredOrders hook to re-run its effect
     */
    resultsTicks: number;
}

export const initialBlotterFilteredOrdersState: BlotterFilteredOrdersState = {
    results: [],
    resultsTicks: 0,
};
